import {
  getCompanyDemoFlags,
  useCompanyDemoFlag,
} from "../../../features/companies/demoFlags";

export const isCentinelaMockEnabled = (): boolean =>
  getCompanyDemoFlags().centinela_demo;

export const showDemoNotices = (): boolean => isCentinelaMockEnabled();

export const useCentinelaDemo = (): boolean =>
  useCompanyDemoFlag("centinela_demo");
